import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MoverGroupEntity } from './mover-group.entity';
import { RbacRoleEntity } from './rbac-role.entity';

@Index('_fk__mover_group__id', ['fkMoverGroupId'], {})
@Index('_fk__rbac_role__id', ['fkRbacRoleId'], {})
@Entity('_mover_group__rbac_role')
export class MoverGroupRbacRoleEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__mover_group__id',
		nullable: true,
		unsigned: true,
	})
	public fkMoverGroupId!: number | null;

	@Column('int', { name: '_fk__rbac_role__id', nullable: true, unsigned: true })
	public fkRbacRoleId!: number | null;

	@Column('smallint', { name: '_sortOrder', nullable: true })
	public sortOrder!: number | null;

	@ManyToOne(
		() => MoverGroupEntity,
		(moverGroup) => moverGroup.moverGroupRbacRoles,
		{
			onDelete: 'NO ACTION',
			onUpdate: 'NO ACTION',
		},
	)
	@JoinColumn([{ name: '_fk__mover_group__id', referencedColumnName: 'id' }])
	public fkMoverGroup!: MoverGroupEntity;

	@ManyToOne(() => RbacRoleEntity, (rbacRole) => rbacRole.moverGroupRbacRoles, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__rbac_role__id', referencedColumnName: 'id' }])
	public fkRbacRole!: RbacRoleEntity;
}
